export default __webpack_public_path__ + "static/rs-68b1ae3ea228755e2dea074fbf61f4ee.svg";